import Vuex from "vuex";
import AuthService from "../services/auth.service";
import VueJwtDecode from "vue-jwt-decode";
export default new Vuex.Store({
  state: {
    sideBarOpen: false,
    loggedIn: false,
    user: JSON.parse(window.localStorage.getItem("user"))
      ? JSON.parse(window.localStorage.getItem("user"))
      : null,
    ticketCart: [],
    totalTicketNumber: 0,
    totalTicketPrice: 0,
    cart: [],
    affiliateId: null,
    eventId: null,
    totalCartItems: 0,
    totalCartPrice: 0,
    origin: null,
  },
  getters: {
    sideBarOpen: (state) => {
      return state.sideBarOpen;
    },

    isLoggedIn: (state) => {
      if (
        window.localStorage.getItem("loggedIn") == "true" &&
        window.localStorage.getItem("userId")
      ) {
        var token = JSON.parse(window.localStorage.getItem("token"));
        var today = new Date();
        var tokenExpiry = new Date(0);
        if (token) {
          tokenExpiry.setUTCSeconds(token.expires);
          if (tokenExpiry < today) {
            state.origin = null;
            state.loggedIn = false;
            window.localStorage.removeItem("userId");
          } else {
            state.origin = "CUSTOMER";
            state.loggedIn = true;
            state.userId = window.localStorage.getItem("userId");
          }
        }
      } else {
        state.loggedIn = false;
      }

      return state.loggedIn;
    },
    getOrigin: (state) => {
      return state.origin;
    },
    getAffiliateId: (state) => {
      var affiliateId = window.localStorage.getItem("affiliateId");

      if (affiliateId != "undefined") {
        state.affiliateId = affiliateId;
        window.localStorage.setItem("affiliateId", state.affiliateId);
      }

      return state.affiliateId;
    },
    getEventId: (state) => {
      var eventId = window.localStorage.getItem("eventId");

      if (eventId != "undefined") {
        state.eventId = eventId;
        window.localStorage.setItem("eventId", state.eventId);
      }

      return state.eventId;
    },
    getTotalTicketPrice: (state) => {
      var totalTicketPrice = window.localStorage.getItem("totalTicketPrice");

      if (totalTicketPrice != "undefined") {
        state.totalTicketPrice = totalTicketPrice;
        window.localStorage.setItem("totalTicketPrice", state.totalTicketPrice);
      }

      return state.totalTicketPrice;
    },
    getTotalTicketNumber: (state) => {
      var totalTicketNumber = window.localStorage.getItem("totalTicketNumber");

      if (totalTicketNumber != "undefined") {
        state.totalTicketNumber = totalTicketNumber;
        window.localStorage.setItem(
          "totalTicketNumber",
          state.totalTicketNumber
        );
      }

      return state.totalTicketNumber;
    },
    getTicketCart: (state) => {
      // window.localStorage.setItem('cart', null);
      // window.localStorage.setItem('cartCount', null);

      if (state.ticketCart.length > 0) {
        return state.ticketCart;
      } else {
        var ticketCart = JSON.parse(window.localStorage.getItem("ticketCart"));

        if (ticketCart) {
          if (ticketCart.length > 0) {
            state.ticketCart = ticketCart;
            window.localStorage.setItem(
              "ticketCart",
              JSON.stringify(state.ticketCart)
            );
          }
        }

        return state.ticketCart;
      }
    },

    getTotalCartPrice: (state) => {
      var totalCartPrice = window.localStorage.getItem("totalCartPrice");

      if (totalCartPrice != "undefined" && totalCartPrice != null) {
        state.totalCartPrice = totalCartPrice;
      }

      return state.totalCartPrice;
    },
    getTotalCartItems: (state) => {
      var totalCartItems = window.localStorage.getItem("totalCartItems");

      if (totalCartItems != "undefined" && totalCartItems != null) {
        state.totalCartItems = totalCartItems;
      }

      return state.totalCartItems;
    },
    getCart: (state) => {
      // window.localStorage.setItem('cart', null);
      // window.localStorage.setItem('cartCount', null);

      if (state.cart.length > 0) {
        return state.cart;
      } else {
        var cart = JSON.parse(window.localStorage.getItem("cart"));

        if (cart) {
          if (cart.length > 0) {
            state.cart = cart;
            window.localStorage.setItem("cart", JSON.stringify(state.cart));
          }
        }

        return state.cart;
      }
    },
  },
  mutations: {
    toggleSidebar(state) {
      state.sideBarOpen = !state.sideBarOpen;
    },
    closeSidebar(state) {
      state.sideBarOpen = false;
    },
    loginSuccess(state, user) {
      state.loggedIn = true;
      state.user = user;
      var decryptedRes = VueJwtDecode.decode(user.body.token);
      window.localStorage.setItem("loggedIn", true);
      window.localStorage.setItem("userId", decryptedRes.sub.split(",")[0]);
    },
    loginFailure(state) {
      state.loggedIn = false;
      state.user = null;
      window.localStorage.removeItem("loggedIn");
      window.localStorage.removeItem("userId");
    },
    logout(state) {
      // Reset all authentication-related state
      state.loggedIn = false;
      state.user = null;
      state.userInfo = null;
      state.userId = null;
      state.origin = null;

      // Update localStorage
      window.localStorage.setItem("loggedIn", false);
      window.localStorage.removeItem("userId");
      window.localStorage.removeItem("token");
    },
    resetFailure(state) {
      state;
    },
    resetSuccess(state) {
      state;
    },
    storeUserInfo(state, userInfo) {
      if (userInfo) {
        (this.state.userInfo = userInfo),
          (this.state.user = userInfo),
          (this.state.userId = userInfo.id);
      }
    },
    updateLoginStatus(state, loggedIn) {
      this.state.loggedIn = loggedIn;
      window.localStorage.setItem("loggedIn", loggedIn);
    },
    dropUserInfo(state) {
      state.origin = null;
      state.userInfo = null;
      state.user = null;
      state.userId = null;
      state.loggedIn = false;
      window.localStorage.removeItem("userId");
    },

    addTicketCart(state, payload) {
      let ticketDetails = payload.ticketDetails;
      let totalTicketNumber = payload.totalTicketNumber;
      let totalTicketPrice = payload.totalTicketPrice;

      let affiliateId = payload.affiliateId;

      state.affiliateId = affiliateId;
      state.ticketCart = ticketDetails;
      state.totalTicketNumber = totalTicketNumber;
      state.totalTicketPrice = totalTicketPrice;
      window.localStorage.setItem(
        "ticketCart",
        JSON.stringify(state.ticketCart)
      );
      window.localStorage.setItem("affiliateId", state.affiliateId);
      window.localStorage.setItem("totalTicketNumber", state.totalTicketNumber);
      window.localStorage.setItem("totalTicketPrice", state.totalTicketPrice);
    },

    addToCart(state, payload) {
      state.cart = JSON.parse(window.localStorage.getItem("cart"));
      let cartItem = {
        productImage: payload.productImage,
        productId: payload.productId,
        productName: payload.productName,
        quantity: payload.quantity,
        specifications: payload.specifications,
        selectedOptionId: payload.selectedOptionId,
        selectedOptionName: payload.selectedOptionName,
        unitPrice: payload.unitPrice,
        totalPrice: payload.totalPrice,
        preparationTime: payload.preparationTime,
      };

      if (state.cart.length < 1) {
        // console.log("cart is empty adding item");
        state.cart.push(cartItem);
      } else {
        // cart is not empty
        for (var i = 0; i < state.cart.length; i++) {
          var p = state.cart[i];

          if (
            p.productId == cartItem.productId &&
            p.selectedOptionId == cartItem.selectedOptionId
          ) {
            // "item already in cart", update figures
            p.quantity = cartItem.quantity;
            p.totalPrice = cartItem.totalPrice;
            p.productImage = cartItem.productImage;
            p.specifications = cartItem.specifications;
            break;
          }

          if (
            !state.cart.find(
              (p) =>
                p.productId == cartItem.productId &&
                p.selectedOptionId == cartItem.selectedOptionId
            )
          ) {
            // console.log("Item not in cart");
            state.cart.push(cartItem);
          }
        }
      }

      window.localStorage.setItem("eventId", payload.eventId);

      //savecart
      this.commit("saveCart");
    },
    saveCart(state) {
      let totalCartPrice = state.cart.reduce(
        (accumulator, currentValue) => accumulator + currentValue.totalPrice,
        0
      );

      let totalCartItems = state.cart.length;

      state.totalCartItems = totalCartItems;
      state.totalCartPrice = totalCartPrice;
      window.localStorage.setItem("cart", JSON.stringify(state.cart));
      window.localStorage.setItem("totalCartItems", state.totalCartItems);
      window.localStorage.setItem("totalCartPrice", state.totalCartPrice);
    },
    increaseQ(state, selectedOptionId) {
      state.cart.map((p) => {
        if (p.selectedOptionId == selectedOptionId) {
          p.quantity += 1;
          p.totalPrice += parseInt(p.unitPrice);
        }
      });

      //savecart
      this.commit("saveCart");
    },
    decreaseQ(state, selectedOptionId) {
      state.cart.map((p) => {
        if (p.selectedOptionId == selectedOptionId) {
          if (p.quantity > 1) {
            p.quantity -= 1;
            p.totalPrice -= parseInt(p.unitPrice);
          }
        }
      });

      //savecart
      this.commit("saveCart");
    },
    removeProduct(state, selectedOptionId) {
      let cart = state.cart.filter(
        (p) => p.selectedOptionId != selectedOptionId
      );
      state.cart = cart;

      console.log(state.cart);
      //savecart
      this.commit("saveCart");
    },
    clearCart(state) {
      let cart = [];
      state.cart = cart;
      state.affiliateId = null;
      state.ticketCart = cart;

      state.totalTicketNumber = 0;
      state.totalTicketPrice = 0;

      window.localStorage.setItem(
        "ticketCart",
        JSON.stringify(state.ticketCart)
      );
      window.localStorage.setItem("affiliateId", state.affiliateId);
      window.localStorage.setItem("totalTicketNumber", state.totalTicketNumber);
      window.localStorage.setItem("totalTicketPrice", state.totalTicketPrice);
      //savecart
      this.commit("saveCart");
    },
  },
  actions: {
    toggleSidebar(context) {
      context.commit("toggleSidebar");
    },
    logout({ commit }, user) {
      try {
        AuthService.logout(user);
        commit("logout");
        return Promise.resolve();
      } catch (error) {
        console.error("Error during logout process:", error);
        // Still try to commit logout state changes even if AuthService fails
        commit("logout");
        return Promise.reject(error);
      }
    },
    login({ commit }, user) {
      return AuthService.login(user).then(
        (user) => {
          commit("loginSuccess", user);
          return Promise.resolve(user);
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },
    googleLogin({ commit }, user) {
      return AuthService.googleLogin(user).then(
        (user) => {
          commit("loginSuccess", user);
          return Promise.resolve(user);
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },
    resetPassword({ commit }, user) {
      return AuthService.resetPassword(user).then(
        (response) => {
          commit("resetSuccess");
          return Promise.resolve(response.data);
        },
        (error) => {
          commit("resetFailure");
          return Promise.reject(error);
        }
      );
    },
    addTicketCart({ commit }, payload) {
      commit("addTicketCart", payload);
    },
    addToCart({ commit }, payload) {
      commit("addToCart", payload);
    },
    increaseQ({ commit }, selectedOptionId) {
      commit("increaseQ", selectedOptionId);
    },
    decreaseQ({ commit }, selectedOptionId) {
      commit("decreaseQ", selectedOptionId);
    },
    removeProduct({ commit }, selectedOptionId) {
      commit("removeProduct", selectedOptionId);
    },
    clearCart({ commit }) {
      commit("clearCart");
    },
  },
});
